/**
 * Result type for operations that may fail.
 *
 * Discriminated union representing success (with value) or failure (with error).
 * Alternative to throwing exceptions.
 *
 * @example
 * ```ts
 * const success: Maybe<number> = { value: 42, error: undefined }
 * const failure: Maybe<number> = { value: undefined, error: new Error("failed") }
 * ```
 */
export type Maybe<T> =
  | {
      error: Error
      value: undefined
    }
  | {
      error: undefined
      value: T
    }
